module.exports = __webpack_public_path__ + "020257d6861043d86239eb3d67cc1200.jpg";